// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35Bh6","left":"styles_left__39_NG"};